import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IFilterAngularComp } from 'ag-grid-angular';
import { AgPromise, IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';

@Component({
    selector: 'app-custom-filter',
    template: `
    <div  class="col-12">
        <input type="text" [(ngModel)]="filterValue" (keyup)="applyFilter($event)" style="width: 100%"/>
    </div>
    `,
    standalone: false // NOSONAR
})

export class CustomFilterComponent implements IFilterAngularComp{

    private params:any;
    public filterValue:string = ''
    /* filterForm = new FormGroup({
        value: new FormControl('')
    }) */
    agInit(params: IFilterParams): void {
        this.params = params;
    }

    applyFilter(event:KeyboardEvent){
        const columnId = this.params.column.colId;
        this.params.filterChangedCallback(this.filterValue, columnId, event.key);
    }
    isFilterActive(): boolean {
        return this.filterValue != '' // NOSONAR
    }
    doesFilterPass(params: IDoesFilterPassParams): boolean {
        
        const cellValue = params.data[this.params.column.colId];
        return cellValue && cellValue?.toLowerCase().includes(this.filterValue.toLowerCase())
    }
    getModel() {
        throw new Error('Method not implemented.');
    }
    setModel(_model: any): void | AgPromise<void> {
        throw new Error('Method not implemented.');
    }
}